/* eslint-disable */
import formValidate from '../modules/formValidate';
import customSelect from '../modules/customSelect';
import { ParamsData } from '../app';


export default form => {
   
    const url = ParamsData.wp_ajax_url;
  //  const msg_error = form.querySelector('.msg-error');
    const hiddens = form.querySelectorAll('.hidden');

    const newsletter_consent = form.querySelector('#newsletter-consent');
    const newsletter_email = form.querySelector('#newsletter-email');
    

    newsletter_email.onclick = () => {
     //  if(newsletter_email.checked) {
        hiddens.forEach(hidden=>hidden.classList.remove('hidden'))
   
      // }else{
      //  hidden.classList.add('hidden');
      // }
    }

    if(newsletter_email.value !== "")  hiddens.forEach(hidden=>hidden.classList.remove('hidden'))
 
    new formValidate(form, () => {
        const formData = new FormData(form);
        formData.append('nonce', form.dataset.nonce);
        formData.append('action', form.getAttribute('action'));
    
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.onload = () => {
            const response = JSON.parse(xhr.response);
            if(response.status === 200){
                form.reset(); 
                hiddens.forEach(hidden=>hidden.classList.add('hidden'));
                newsletter_email.classList.remove('notempty');
            }
            if(response.status === 300 || response.status === 500){
                console.log(response.msg);
               // msg_error.classList.add('show');
            }
          
        }
        xhr.send(formData);
    });

    document.querySelectorAll('.customSelect').forEach(el => customSelect(el));

}